var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.account_tb") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            _c("div", { staticClass: "requestsList" }, [
              _c("div", { staticClass: "mt-0" }, [
                _c(
                  "div",
                  [
                    _c("AccountTBList", {
                      attrs: { type: _vm.TrackType, id: _vm.id },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }